<template>
<Form ref="form" @submit="onSubmit">
        <div class="modal-header">
            <h4 class="modal-title">
                {{ $getLocaleMessage('formTitles', 'create') }} documento
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="card-body">
                <div class="form-group">
                    <div class="form-group">
                        <label for="documentName">Nombre:</label>
                        <Field v-model="form.documentName" type="text" class="form-control" name="documentName"
                            placeholder="Nombre" rules="required"/>
                        <ErrorMessage name="documentName" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <label for="statusId">Estatus:</label>
                    <StatusSelect v-model="form.statusId" :name="'statusId'" :options="statusOptions"></StatusSelect>                
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $getLocaleMessage('buttons', 'cancel') }}</button>
            <PrimaryButton class="btn btn-primary" type="submit">
                {{ $getLocaleMessage('buttons', 'create') }}
            </PrimaryButton>
        </div>
    </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from 'pinia';
import { documentsStore } from '@/pinia/documents.module';
import { useStatusStore } from '@/pinia/status.module';

import PrimaryButton from "@/Components/PrimaryButton.vue";
import StatusSelect from '@/Components/Selects/SelectField.vue';

export default {
    components: {
        PrimaryButton,
        StatusSelect,
    },
    data() {
        return {
            form: {
                companyId: 1
            },
        };
    },
    emits: ['close-modal'],
    computed: {
        ...mapState(useStatusStore, ['getAllStatusByType', 'getSelectedStatus']),
        statusOptions() {
            return helper.mapOptions(this.getAllStatusByType(5));
        },
    },
    methods: {
        ...mapActions(documentsStore, ['createDocument']),
        onSubmit() {
            this.createDocument(this.form);
            this.$refs.form.resetForm();
            this.closeModal();
        },
        closeModal() {
            this.$emit('close-modal', true);
        },
    },
};
</script>